module.exports = __webpack_public_path__ + "img/marketplace-ipad-1500x1500.53a7f9b3.png";